import React, { useState } from "react";
import "./LogsPage.css";

import EmailLogs from "../Emails/EmailsLogs";
import ApplicationLogs from "./ApplicationLogs";
import SessionLogs from "./SessionLogs";

const LogsPage = () => {
    const [activeTab, setActiveTab] = useState("APP");

    return (
        <div className="logs-page">
            <div className="logs-page-header">
                <div>
                    <h2>Historique des actions</h2>
                </div>
            </div>

            <div className="logs-tabs">
                <button
                    className={`logs-tab ${activeTab === "APP" ? "active" : ""}`}
                    onClick={() => setActiveTab("APP")}
                >
                    Logs applicatifs
                </button>

                <button
                    className={`logs-tab ${activeTab === "EMAIL" ? "active" : ""}`}
                    onClick={() => setActiveTab("EMAIL")}
                >
                    Logs des emails
                </button>

                <button
                    className={`logs-tab ${activeTab === "SESSIONS" ? "active" : ""}`}
                    onClick={() => setActiveTab("SESSIONS")}
                >
                    Sessions utilisateurs
                </button>
            </div>

            <div className="logs-tab-content">
                {activeTab === "APP" && <ApplicationLogs />}
                {activeTab === "EMAIL" && <EmailLogs />}
                {activeTab === "SESSIONS" && <SessionLogs />}
            </div>
        </div>
    );
};

export default LogsPage;